/* ============================================================
   TAVOR.JS — TAV&OR Vanilla JS Module
   ============================================================ */

(function () {
  'use strict';

  /* ── FLOATING NAV ─────────────────────────────────────── */
  function initFloatingNav() {
    /* tavor-nav.liquid has its own inline scroll handler targeting
       #tavor-nav directly. This function is intentionally a no-op
       to avoid double-binding scroll events and conflicting lastY state. */
    return;
  }

  /* ── MOBILE NAV OVERLAY ───────────────────────────────── */
  function initMobileNav() {
    /* tavor-nav.liquid sets data-mobile-nav-ready on the hamburger
       after attaching all handlers (open, close, backdrop, links, keyboard).
       If that flag is present, skip — adding a second set of listeners
       causes a stripped-down close() that does NOT remove tavor-menu-open,
       which leaves #MainContent visibility:hidden and the page stuck blank. */
    var hamburger = document.querySelector('.tavor-nav__hamburger');
    if (!hamburger || hamburger.dataset.mobileNavReady) return;

    /* Fallback path: inline script didn't run (e.g. very old browser that
       blocked inline scripts). Wire up minimal open/close. */
    var overlay = document.querySelector('.tavor-nav-overlay');
    var closeBtn = document.querySelector('.tavor-nav-overlay__close');
    if (!overlay) return;

    function openMenu() {
      overlay.classList.add('is-open');
      document.body.classList.add('tavor-menu-open');
      document.body.style.overflow = 'hidden';
      hamburger.setAttribute('aria-expanded', 'true');
    }
    function closeMenu() {
      overlay.classList.remove('is-open');
      document.body.classList.remove('tavor-menu-open');
      document.body.style.overflow = '';
      hamburger.setAttribute('aria-expanded', 'false');
    }

    hamburger.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeMenu(); });
    overlay.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMenu); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
  }

  /* ── SCROLL REVEAL ────────────────────────────────────── */
  function initScrollReveal() {
    var elements = document.querySelectorAll('.tavor-reveal');
    if (!elements.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach(function (el, i) {
      el.style.transitionDelay = (i * 100) + 'ms';
      observer.observe(el);
    });
  }

  /* ── ACCORDION ────────────────────────────────────────── */
  function initAccordion() {
    var items = document.querySelectorAll('.tavor-accordion__item');
    items.forEach(function (item) {
      var trigger = item.querySelector('.tavor-accordion__trigger');
      var body = item.querySelector('.tavor-accordion__body');
      if (!trigger || !body) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (i) {
          i.classList.remove('is-open');
          var b = i.querySelector('.tavor-accordion__body');
          if (b) b.style.maxHeight = '0';
          var t = i.querySelector('.tavor-accordion__trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          body.style.maxHeight = body.scrollHeight + 'px';
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ── PRODUCT PAGE — SIZE SELECTOR ────────────────────── */
  function initSizeSelector() {
    var btns = document.querySelectorAll('.tavor-size-selector__btn');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
        var variantSelect = document.querySelector('.tavor-variant-select');
        if (variantSelect && btn.dataset.variant) {
          variantSelect.value = btn.dataset.variant;
          variantSelect.dispatchEvent(new Event('change'));
        }
      });
    });
  }

  /* ── COLOUR SWATCHES ──────────────────────────────────── */
  function initColourSwatches() {
    var swatches = document.querySelectorAll('.tavor-swatch');
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var group = swatch.closest('.tavor-swatches');
        if (group) {
          group.querySelectorAll('.tavor-swatch').forEach(function (s) {
            s.classList.remove('is-selected');
            s.setAttribute('aria-pressed', 'false');
          });
        }
        swatch.classList.add('is-selected');
        swatch.setAttribute('aria-pressed', 'true');
      });
    });
  }

  /* ── PRODUCT GALLERY — THUMBNAILS + AUTO-SLIDE ────────── */
  function initGallery() {
    var thumbs = document.querySelectorAll('.tavor-product-gallery__thumb');
    var slides = document.querySelectorAll('.tavor-product-gallery__slide');
    var mainImg = document.querySelector('.tavor-product-gallery__main img');
    var timer;
    var current = 0;

    if (thumbs.length && mainImg && !slides.length) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          if (thumb.dataset.src) mainImg.src = thumb.dataset.src;
        });
      });
      return;
    }

    if (!slides.length) return;

    function goTo(n) {
      slides[current].classList.remove('is-active');
      if (thumbs[current]) { thumbs[current].classList.remove('is-active'); thumbs[current].setAttribute('aria-pressed', 'false'); }
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (thumbs[current]) { thumbs[current].classList.add('is-active'); thumbs[current].setAttribute('aria-pressed', 'true'); }
    }

    function startAuto() { timer = setInterval(function () { goTo(current + 1); }, 3500); }
    function stopAuto()  { clearInterval(timer); }

    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () { stopAuto(); goTo(i); startAuto(); });
    });

    var galleryPrimary = document.querySelector('.tavor-product-gallery__primary');
    if (galleryPrimary) {
      galleryPrimary.addEventListener('mouseenter', stopAuto);
      galleryPrimary.addEventListener('mouseleave', startAuto);
    }

    startAuto();
  }

  /* ── SIZE GUIDE MODAL ─────────────────────────────────── */
  function initSizeModal() {
    var trigger = document.querySelector('.tavor-size-selector__guide');
    var modal = document.querySelector('.tavor-modal');
    var closeBtn = document.querySelector('.tavor-modal__close');
    if (!trigger || !modal) return;

    var open = function () { modal.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    var close = function () { modal.classList.remove('is-open'); document.body.style.overflow = ''; };

    trigger.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ── CURSOR LIGHT-REVEAL ──────────────────────────────── */
  function initCursorReveal() {
    var hero  = document.getElementById('tavor-hero');
    var lit   = document.getElementById('tavor-hero-lit');
    var glow  = document.getElementById('tavor-hero-glow');
    if (!hero || !lit || !glow) return;

    var tx = hero.offsetWidth / 2;
    var ty = hero.offsetHeight / 2;
    var cx = tx;
    var cy = ty;

    hero.addEventListener('pointermove', function (e) {
      var r = hero.getBoundingClientRect();
      tx = e.clientX - r.left;
      ty = e.clientY - r.top;
    }, { passive: true });

    (function loop() {
      cx += (tx - cx) * 0.35;
      cy += (ty - cy) * 0.35;
      lit.style.setProperty('--mx', cx + 'px');
      lit.style.setProperty('--my', cy + 'px');
      glow.style.transform = 'translate3d(' + (cx - 230) + 'px,' + (cy - 230) + 'px,0)';
      requestAnimationFrame(loop);
    })();
  }

  /* ── INIT ─────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initFloatingNav();
    initMobileNav();
    initScrollReveal();
    initAccordion();
    initSizeSelector();
    initColourSwatches();
    initGallery();
    initSizeModal();
    initCursorReveal();
  });
})();
